var _placeholder = /*#__PURE__*/require("./_placeholder.js");
function _isPlaceholder(a) {
  return a === _placeholder;
}
module.exports = _isPlaceholder;